import { Component } from '@angular/core';

import { AppService } from '@/service/app.service';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `
        <div class="layout-footer">
            {{ appService.appName }}
        </div>
    `
})
export class AppFooter {
    constructor(public appService: AppService) {
    }
}
